module.exports = __webpack_public_path__ + "visual-d.png";